<div class="pti-container">
  <!-- Header -->
  <div class="pti-header">
    <div class="pti-title">
      <img class="pti-favicon" src="assets/icons/icon-32.png" alt="NuageDx"
           (error)="faviconError = true" *ngIf="!faviconError" />
      <mat-icon class="pti-favicon-fallback" *ngIf="faviconError" svgIcon="nuagedx-cloud"></mat-icon>
      <span class="pti-app-name">Images Send</span>
    </div>
    <button class="pti-close-btn" mat-icon-button (click)="onCancel()" title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="pti-content">
    <!-- Patient info grid -->
    <div class="pti-info-grid">
      <div class="pti-field pti-field--highlighted">
        <span class="pti-field__label">Patient ID</span>
        <span class="pti-field__value">{{ patientId || '—' }}</span>
      </div>
      <div class="pti-field pti-field--highlighted">
        <span class="pti-field__label">Patient Name</span>
        <span class="pti-field__value">{{ patientName || '—' }}</span>
      </div>
      <div class="pti-field">
        <span class="pti-field__label">Date of Birth</span>
        <span class="pti-field__value">{{ dateOfBirth || '—' }}</span>
      </div>
      <div class="pti-field">
        <span class="pti-field__label">Gender</span>
        <span class="pti-field__value">{{ gender || '—' }}</span>
      </div>
    </div>

    <!-- Facility transfer visualization -->
    <div class="pti-transfer" *ngIf="targetFacility">
      <div class="pti-facility pti-facility--source">
        <span class="pti-facility__label">Source</span>
        <span class="pti-facility__name">{{ sourceFacility || 'Your Facility' }}</span>
      </div>

      <div class="pti-arrows">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="pti-facility pti-facility--target">
        <span class="pti-facility__label">Facility</span>
        <span class="pti-facility__name">{{ targetFacility }}</span>
      </div>
    </div>

    <!-- Instructions -->
    <div class="pti-instructions">
      <p class="pti-instructions__title">Your next step</p>
      <ol class="pti-instructions__list">
        <li>In your PACS system, find the studies and share them to NuageDx.</li>
        <li>When finished, click on CONTINUE</li>
      </ol>
    </div>

    <!-- Actions -->
    <div class="pti-actions">
      <button class="pti-btn pti-btn--continue" (click)="onContinue()">
        <mat-icon>grid_view</mat-icon>
        Continue
      </button>
    </div>
  </div>
</div>
